<template>
    <v-card class="mx-auto my-4" max-width="400" hover :to="{ name: 'AnnouncementDetail', params: { id: announcement.id } }">
      <v-img
         height="200"
         :src="imageUrl"
         cover
         class="text-white"
       >
         <v-toolbar density="compact" color="rgba(0, 0, 0, 0.4)">
           <v-toolbar-title class="text-truncate">{{ announcement.title }}</v-toolbar-title>
           <v-spacer></v-spacer>
           <v-chip v-if="announcement.is_verified" color="success" size="small" prepend-icon="mdi-check-decagram">Onaylı</v-chip>
         </v-toolbar>
       </v-img>
  
  
      <v-card-text>
        <div class="font-weight-bold ms-1 mb-2">
          {{ announcement.title }}
        </div>
  
        <v-timeline density="compact" align="start">
            <v-timeline-item v-if="announcement.price" dot-color="primary" size="x-small">
                <div class="mb-1">
                  <div class="font-weight-normal">
                    <strong>Fiyat</strong>
                  </div>
                  <div>{{ formattedPrice }}</div>
                </div>
            </v-timeline-item>
  
           <v-timeline-item v-if="announcement.location" dot-color="green" size="x-small">
                <div class="mb-1">
                  <div class="font-weight-normal">
                    <strong>Konum</strong>
                  </div>
                  <div>{{ announcement.location }}</div>
                </div>
            </v-timeline-item>
  
             <v-timeline-item v-if="announcement.user" dot-color="grey" size="x-small">
                <div class="mb-1">
                   <div class="font-weight-normal">
                     <strong>İlan Sahibi</strong>
                   </div>
                  <div>{{ announcement.user.username }} <span v-if="announcement.user.profile_title">({{ announcement.user.profile_title }})</span></div>
                </div>
            </v-timeline-item>
        </v-timeline>
  
         </v-card-text>
  
      <v-card-actions>
         <v-spacer></v-spacer>
        <v-btn color="primary" variant="text">
          Detaylar
        </v-btn>
         </v-card-actions>
    </v-card>
  </template>
  
  <script>
  export default {
    name: 'AnnouncementCard',
    props: {
      announcement: {
        type: Object,
        required: true
      }
    },
    computed: {
      formattedPrice() {
        if (this.announcement.price === null || this.announcement.price === undefined) {
          return 'Belirtilmemiş';
        }
        // Fiyatı para birimi formatına çevir (Türk Lirası)
        return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(this.announcement.price);
      },
       imageUrl() {
        // Eğer resim varsa ve URL'si varsa, onu kullan. Yoksa varsayılan bir resim göster.
        const defaultImage = 'https://cdn.vuetifyjs.com/images/cards/docks.jpg'; // Varsayılan resim
        const backendBaseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:5001'; // Backend adresi
  
        if (this.announcement.images && this.announcement.images.length > 0 && this.announcement.images[0].url) {
           // URL'nin başına backend adresini ekle (eğer göreceli path ise)
           const imgUrl = this.announcement.images[0].url;
           // Eğer URL '/' ile başlamıyorsa veya http içermiyorsa başına backend adresini ekle
           if (!imgUrl.startsWith('/') && !imgUrl.startsWith('http')) {
              // api.js'deki baseURL'den /api kısmını çıkaralım
               const baseUrl = backendBaseUrl.replace('/api', '');
               return `${baseUrl}/${imgUrl}`;
           }
           // Eğer URL zaten tam ise (örn: /uploads/...) veya http ile başlıyorsa direkt kullan
           if (imgUrl.startsWith('/')) {
               const baseUrl = backendBaseUrl.replace('/api', '');
               return `${baseUrl}${imgUrl}`;
           }
           return imgUrl;
        }
        return defaultImage;
      }
    },
     methods: {
       toggleFavorite() {
         // TODO: Favori ekleme/çıkarma işlemi (Vuex action çağrısı)
         console.log('Toggle favorite for announcement:', this.announcement.id);
       }
     }
  };
  </script>
  
  <style scoped>
  /* Kartlara özel stiller */
  </style>